/**
 * TURAQ Pro (docs/PRO_PLATFORM_PLAN.md): new profiles, new buildings, the
 * cabinet and /ui-kit. On when the build says VITE_PRO=true (production now)
 * and in `yarn dev`. `?pro=1` / `?pro=0` in the URL override it:
 *  - where Pro is off by default, `?pro=1` is remembered (to show the work
 *    on a build before the switch);
 *  - where Pro is on, `?pro=0` lasts for this tab only. It used to be stored
 *    for good, so a browser that once opened `?pro=0` kept showing the old
 *    site — the «new version disappears sometimes» reports.
 */
const KEY = "turaq-pro";
const BUILD_DEFAULT = import.meta.env.VITE_PRO === "true" || import.meta.env.DEV;

function override(): boolean | null {
  if (typeof window === "undefined") return null;
  try {
    const q = new URLSearchParams(window.location.search).get("pro");
    if (BUILD_DEFAULT) {
      // A remembered «off» from earlier previews must not hide the shipped site.
      if (localStorage.getItem(KEY) === "0") localStorage.removeItem(KEY);
      if (q === "0") sessionStorage.setItem(KEY, "0");
      if (q === "1") sessionStorage.removeItem(KEY);
      return sessionStorage.getItem(KEY) === "0" ? false : null;
    }
    if (q === "1") localStorage.setItem(KEY, "1");
    if (q === "0") localStorage.setItem(KEY, "0");
    const v = localStorage.getItem(KEY);
    return v === "1" ? true : v === "0" ? false : null;
  } catch {
    return null;
  }
}

export const proEnabled: boolean = override() ?? BUILD_DEFAULT;
